import kr from "../../kr/kr";

export default class AudioPlayer extends kr.Component {
  init() {
    window.onload = () => {
        this.$element.querySelector('audio').play();
    }
  }
}

kr.registerComponent(".js_placeMp3", {
  component: AudioPlayer,
});
